import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_KEY,
    'Content-Type': 'application/json',
  },
});

export function setupAxiosInterceptors(msalInstance) {
  axiosInstance.interceptors.request.use(async (config) => {
    try {
      const token = await getAuthToken(msalInstance);
      const username = msalInstance.getActiveAccount().username;
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['username'] = username;
      } else {
        console.warn('No token available for request');
      }
    } catch (error) {
      console.error('Error getting auth token:', error);
    }
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        sessionStorage.removeItem('access_token');

        try {
          const newToken = await getAuthToken(msalInstance);
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

          return axiosInstance(originalRequest);
        } catch (error) {
          return Promise.reject(error);
        }
      }

      return Promise.reject(error);
    }
  );
}

export async function getAuthToken(msalInstance) {
  let token = sessionStorage.getItem('access_token');

  if (!token) {
    if (process.env.REACT_APP_DEV_ENABLED === 'true') {
      // If no token is found, use credentials from .env to obtain a new token
      const username = process.env.REACT_APP_USERNAME;
      const password = process.env.REACT_APP_PASSWORD;

      const response = await axios.post(process.env.REACT_APP_LOGIN_URL, {
        username,
        password,
      });

      if (response.data && response.data.access_token) {
        token = response.data.access_token;
        sessionStorage.setItem('access_token', token); // Store the new token
        console.log('access token');
      } else {
        console.log('no token');
        throw new Error('Failed to obtain access token');
      }
    } else {
      const clientId = process.env.REACT_APP_CLIENT_ID;
      const tokenRequest = {
        scopes: ['api://' + clientId + '/CPQ_Scope'],
        account: msalInstance.getActiveAccount(),
      };

      const response = await msalInstance.acquireTokenSilent(tokenRequest);
      token = response.accessToken;
      sessionStorage.setItem('access_token', token); // Store the new token
    }
  }

  return token;
}
